const faqData = [
  {
    id: 1,
    question: "Dimana Cemara valas beroperasi? ",
    answer:
      "Kami berada di jalan boulevard Raya No.8 AM, Komplek Cemara Asri",
  },
  {
    id: 2,
    question: "Apakah Cemara Valas aman?",
    answer:
      "Jangan khawatir, tukar uang di Cemara Valas 100% aman karena kami telah mendapatkan izin langsung dari Bank Indonesia.",
  },
    /*
  {
    id: 3,
    question: "Metode pembayaran apa saja yang tersedia?",
    answer:
      "Pembayaran bisa dilakukan via transfer ke rekening resmi kami atau secara langsung dengan cash di counter offline.",
  },

  {
    id: 4,
    question: "Apakah Cemara Valas Melayani transaksi Non-tunai?",
    answer:
      "kenyamanan dan kemudahan transaksi customer adalah prioritas kami. Pembayaran tunai dan Non-tunai dapat dilakukan dengan melampirkan form dan ketentuan mengikuti Bank Indonesia.",
  },
     */
  {
    id: 5,
    question: "Bagaimana cara tukar uang di Cemara Valas?",
    answer:
      "Untuk penukaran secara online, kamu bisa menghubungi tim kami melalui WA di nomor\n" +
        "+62 82178208800. Untuk penukaran secara offline, bisa langsung mengunjungi counter kami yang berlokasi di Boulevard Raya N0.8AM, cemara Asri.\n",
  },
  {
    id: 6,
    question: "Dokumen apa yang dibutuhkan untuk bertransaksi? ",
    answer:
      "Dokumen sesuai ketentuan Bank Indonesia adalah Kartu Tanda Penduduk (KTP), SIM, Passport ataupun dokumen pengenal lainnya yang legal.",
  },
];

export default faqData;
